import {h, Fragment} from "preact"
import { colors } from "../../config"

export default function Checkbox({ value, selected, onChange, className, labelText, isColor }) {

    return (
        <label className={`ns-checkbox-label ${className}`}>
            <input 
                type="checkbox" 
                class="sr-only visually-hidden" 
                value={value}
                checked={selected}
                onChange={onChange}
            />
            <span 
                aria-hidden="true" 
                role="presentation"
                class="ns-checkmark block"
                style={isColor ? { background: colors[value.toLowerCase().trim()] } : {}}
            />
            <span class="ns-filter-text">{labelText}</span> 
        </label>
    )
}